import { gql } from "@apollo/client";
import { Button, ButtonBase, Paper } from "@mui/material";
import DateTime from "atoms/DateTime";
import VideoThumbnail from "atoms/VideoThumbnail";
import { FONT_FAMILY_LEAGUE_GOTHIC, FONT_FAMILY_PATHWAY_GOTHIC_ONE } from "helpers/FONT";
import { SPACING, SPACING_HALF } from "helpers/spacings";
import { ChartBar } from "mdi-material-ui";
import getCompetitionStyle from "pages/potw/getCompetitionStyle";
import React from "react";

export const GameEntryFragment = gql`
  fragment GameEntryFragment on Game {
    id
    thumbnailUrl
    videoProcessing
    videoArchived
    homeScore
    awayScore
    playedAt
    home {
      id
      name
    }
    away {
      id
      name
    }
    livePotwCompetition {
      id
      competitionType
    }
  }
`;

export default function GameEntry({ game }) {
  const competitionStyle = game.livePotwCompetition && getCompetitionStyle(game.livePotwCompetition?.competitionType);

  return (
    <Paper
      key={game.id}
      style={{
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "stretch",
        overflow: "hidden",
      }}
    >
      <VideoThumbnail
        component={ButtonBase}
        style={{ flex: "1 1 auto" }}
        thumbnailUrl={game.thumbnailUrl}
        processing={game.videoProcessing}
        videoArchived={game.videoArchived}
        href={`/game/${game.id}/video`}
        focusRipple
      />
      <div
        style={{
          flex: "100 100 300px",
          display: "flex",
          flexFlow: "column nowrap",
          padding: SPACING,
          gap: SPACING_HALF,
        }}
      >
        <div
          style={{
            fontFamily: FONT_FAMILY_PATHWAY_GOTHIC_ONE,
            textTransform: "uppercase",
            fontSize: 20,
            lineHeight: 1,
          }}
        >
          <span>{game.home.name}</span>
          <span
            style={{
              opacity: 0.5,
              fontSize: ".5em",
              margin: "0 .25em",
            }}
          >
            vs
          </span>
          <span>{game.away.name}</span>
        </div>
        <div style={{ opacity: 0.5 }}>
          <DateTime value={game.playedAt} variant="date" />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "stretch",
          alignItems: "center",
          flex: "1 1 auto",
        }}
      >
        {competitionStyle && (
          <img
            src={competitionStyle.logoImage}
            alt={competitionStyle.title}
            style={{
              height: "3em",
            }}
          />
        )}
        <Button
          style={{ flex: "1 1 auto", margin: SPACING_HALF }}
          color="inherit"
          variant="outlined"
          href={`/game/${game.id}/overview`}
        >
          <ChartBar />
          View Game
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: 34,
          fontFamily: FONT_FAMILY_LEAGUE_GOTHIC,
          fontWeight: 400,
          padding: 20,
          flex: "1 1 130px",
        }}
      >
        <div>{game.homeScore}</div>
        <div style={{ fontSize: ".5em", opacity: 0.5 }}>vs</div>
        <div>{game.awayScore}</div>
      </div>
    </Paper>
  );
}
